import React from 'react';
import { Carousel } from 'react-bootstrap';
import './Hero.css';
//import sairam_banner from '../Assets/sairam_banner.png';
import banner_delivery from '../Assets/banner-delivery.png';
import banner_oil from '../Assets/banner-Oils.png';
// import hero_image from '../Assets/banner-dal.png';

const Hero = () => {

  return (
    <Carousel>
{/* 
<Carousel.Item>
        <img
          className="d-block w-100"
          src={sairam_banner}
          alt="First slide"
        />
        <Carousel.Caption>
          { <h3>Delivery</h3>
          <p>Fast and reliable delivery service.</p>}
        </Carousel.Caption>
      </Carousel.Item> */}
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={banner_delivery}
          alt="First slide"
        />
        <Carousel.Caption>
          {/* <h3>Delivery</h3>
          <p>Fast and reliable delivery service.</p> */}
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <img
          className="d-block w-100"
          src={banner_oil}
          alt="Second slide"
        />
        <Carousel.Caption>
          {/* <h3>Our Services</h3>
          <p>Efficient solutions for your needs.</p> */}
        </Carousel.Caption>
      </Carousel.Item>

      {/* <Carousel.Item>
        <img
          className="d-block w-100"
          src={hero_image}
          alt="Third slide"
        />
        <Carousel.Caption>
          <h3>Explore More</h3>
          <p>Discover all the possibilities we offer.</p>
        </Carousel.Caption>
      </Carousel.Item> */}
    </Carousel>
  );
}

export default Hero